module.exports = __webpack_public_path__ + "static/drawing-4ab9a3aa724579308ee860c2729ec475.png";